
export default {
  name: 'VsFilterableList',
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      default: null
    },
    filterBy: {
      type: String,
      default: null
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: String,
      default: '10rem'
    },
    itemTag: {
      type: String,
      default: 'vs-dropdown-item'
    },
    itemProps: {
      type: Object,
      default: null
    },
    inputProps: {
      type: Object,
      default: () => {
        return {
          placeholder: 'Search',
          size: 'small'
        }
      }
    },
    noDataText: {
      type: String,
      default: 'No Data'
    },
    noResultsText: {
      type: String,
      default: 'No Results'
    },
    expand: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    search: {
      marginBottom: 'xs',
      borderColor: 'grey-lighter',
      $expand: {
        borderBottomWidth: (val) => !val && 1,
        padding: (val) => !val && 'xs'
      }
    },
    list: {
      $expand: {
        paddingBottom(val) {
          return !val && this.visibleItems.length ? 'xs' : null
        }
      }
    }
  },
  watch: {
    search(newVal) {
      if (newVal) {
        this.currentIndex = -1
      }
    }
  },
  data() {
    return {
      search: '',
      currentIndex: -1
    }
  },
  computed: {
    wrapperComponent() {
      return this.scrollable ? 'vs-scrollbar' : 'vs-node'
    },
    wrapStyle() {
      return `max-height: ${this.maxHeight};`
    },
    visibleItems() {
      const term = this.search.toLowerCase()
      const exp = RegExp(term, 'gi')
      const key = this.filterBy

      return this.items.filter((item) => item[key].toLowerCase().search(exp) > -1)
    },
    showSearch() {
      return this.items.length
    },
    noResults() {
      return this.items.length && !this.visibleItems.length
    },
    isFirstSelected() {
      return this.currentIndex == 0
    },
    isLastSelected() {
      return this.currentIndex == this.visibleItems.length - 1
    }
  },
  methods: {
    onSelect(data, index) {
      this.currentIndex = index
      this.highlight()

      this.$emit('select', data, index)
      this.search = ''
    },
    onKeyUp() {
      if (this.visibleItems.length) {
        this.currentIndex = this.isFirstSelected
          ? this.visibleItems.length - 1
          : this.currentIndex - 1

        this.highlight()
      } else {
        this.currentIndex = -1
      }
    },
    onKeyDown() {
      if (this.visibleItems.length) {
        this.currentIndex = this.isLastSelected
          ? 0
          : this.currentIndex + 1

        this.highlight()
      } else {
        this.currentIndex = -1
      }
    },
    focusInput() {
      this.$refs.input.focus()
    },
    onEscape() {
      this.focusInput()
    },
    highlight() {
      const selected = this.$refs[`item-${this.currentIndex}`]

      if (selected) {
        selected.$el.focus()
      }
    }
  }
}
